import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

const LazyAdminMarketing = lazy(
  () => import(/* webpackChunkName: 'AdminMarketing' */ './index'),
);

export default function AdminMarketing() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyAdminMarketing />
    </Suspense>
  );
}
